<template>
  <v-card flat>
    <!-- Datatable filter -->
    <v-card-title v-if="xpathMappingKeysList.length > 0">
      <v-layout row wrap>
        <v-flex sm6>
          <v-text-field append-icon="filter_list" :label="messages.label.XPATH_MAPPINGS_FILTER" single-line clearable
            hide-details @input="value => filterXpathMappingsList(value)" v-model="filterInput">
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-card-title>
    <!-- Data Table -->
    <v-card-text>
      <v-data-table :headers="headers" :items="filteredMappings" :loading="xpathMappingKeysListLoading"
        :rows-per-page-items="rowsPerPagesArray">
        <!-- Items -->
        <template slot="items" slot-scope="props">
          <tr @click="showSelectedXPathMappingDetails(props.item)"
            :active="!!selectedXpathKey && selectedXpathKey.id == props.item.id" class="pointer">
            <td class="text-xs-left">{{ props.item.key }}</td>
          </tr>
        </template>
        <!-- No Data -->
        <template slot="no-data">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            {{ messages.info.NO_XPATH_MAPPINGS }}
          </v-alert>
        </template>
        <!-- No Results -->
        <template slot="no-results">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            {{ messages.info.NO_FILTER_XPATH_MAPPINGS }}
          </v-alert>
        </template>
        <!-- Page Text -->
        <template slot="pageText" slot-scope="props">
          {{ props.pageStart }} - {{ props.pageStop }} of
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import messages from "@/XVAT/messages.json"
import XVATRulesService from "@/XVAT/XVATRulesService"
import { SET_SELECTED_XPATH_KEY, SET_SHOW_XPATH_DETAILS } from "@/store/constants/mutation-types"

/**
 * initialData
 */
function initialData(instance) {
  return {
    filterInput: "",
    filteredMappings: [],
    rowsPerPagesArray: [25, 50, 75, 100],
    headers: instance.getTableHeaders()
  }
}

export default {
  name: "XPathMappingsList",
  data: function () {
    return initialData(this)
  },
  computed: {
    ...mapState("xvat", [
      "xpathMappingKeysList",
      "xpathMappingKeysListLoading",
      "selectedXpathKey"
    ])
  },
  watch: {
    xpathMappingKeysList: {
      handler(newVal, oldVal) {
        // console.log(newVal, oldVal)
        if (newVal !== oldVal) {
          this.filterXpathMappingsList(this.filterInput)
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations("xvat", [
      SET_SELECTED_XPATH_KEY,
      SET_SHOW_XPATH_DETAILS
    ]),

    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData(this))
    },

    /**
     * getTableHeaders - Construct array of objects to show table headers
     *
     * @return {array}
     */
    getTableHeaders() {
      let headers = [
        {
          text: messages.label.TH_KEY,
          align: "left",
          sortable: false,
          value: "key"
        }
      ]
      return headers
    },

    /**
     * filterXpathMappingsList - Filter search result with text value
     * NOTE: This filters available objects on the client
     * @param {string} search
     */
    filterXpathMappingsList(search) {
      if (search) {
        search = search.toString().toLowerCase()
        const displayedKeys = ["key"]
        this.filteredMappings = this.xpathMappingKeysList.filter(obj => {
          let filteredObj = this.$lodash.pick(obj, displayedKeys)
          return Object.keys(filteredObj).some(function (key) {
            if (filteredObj[key] !== null) {
              return filteredObj[key]
                .toString()
                .toLowerCase()
                .includes(search)
            }
          })
        })
      } else {
        this.filteredMappings = this.xpathMappingKeysList
      }
    },

    /**
     * showSelectedXPathMappingDetails- Show selected provider gorup details
     * @param {object} xpathMapping
     */
    showSelectedXPathMappingDetails(xpathMapping) {
      this.SET_SELECTED_XPATH_KEY(xpathMapping)
      this.SET_SHOW_XPATH_DETAILS(true)
    },
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     */
  },
  beforeUnmount() {
  },
  beforeDestroy() {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/XVAT/XpathMapping/XPathMappingsList.vue